import Api from "~/service/Api";

class TourBulkUpdateRepository {
  update(locale, data) {
    return Api.put(`/${locale}/tour/bulk-updates`, data);
  }
}

export default TourBulkUpdateRepository;
